.fxg6de1 {
  container-name: fxg6de0;
  container-type: inline-size;
}
.fxg6de2 {
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  grid-template-areas: "rail main";
  min-height: 100%;
}
.fxg6de3 {
  grid-area: rail;
  background-color: var(--pluma-color-surface-base);
  border-right: var(--pluma-border-width-0125) solid var(--pluma-color-scope-neutral-subtle-border);
  padding: var(--pluma-space-300) var(--pluma-space-150);
}
.fxg6de4 {
  padding-inline: var(--pluma-space-100);
}
.fxg6de5 {
  padding: var(--pluma-space-100);
  border-radius: var(--pluma-radius-8);
}
.fxg6de5:nth-child(odd) {
  background-color: var(--pluma-color-scope-neutral-subtle-bg);
}
.fxg6de6 {
  grid-area: main;
  position: relative;
  background-color: var(--pluma-color-surface-content);
  padding: var(--pluma-space-400) var(--pluma-space-300) var(--pluma-space-300);
}
.fxg6de7 {
  position: absolute;
  top: var(--pluma-space-200);
  right: var(--pluma-space-200);
}
.fxg6de8 {
  text-align: center;
}
.fxg6de9 {
  padding: var(--pluma-space-100);
}
.fxg6dea {
  display: flex;
  flex-direction: column;
  width: min(940px, calc(100vw - 2 * var(--pluma-space-200)));
  max-height: calc(100vh - 2 * var(--pluma-space-200));
  overflow: hidden;
  background-color: var(--pluma-color-surface-content);
  border-radius: var(--pluma-radius-10);
  box-shadow: var(--pluma-depth-surface-3);
  opacity: 1;
  transform: none;
  transition: opacity var(--pluma-c-plain-modal-animation-transition-duration, var(--pluma-c-_plain-modal-animation-transition-duration, 0ms)) ease, transform var(--pluma-c-plain-modal-animation-transition-duration, var(--pluma-c-_plain-modal-animation-transition-duration, 0ms)) var(--pluma-motion-easing-entrance-expressive);
}
.fxg6dea[data-status="initial"], .fxg6dea[data-status="close"] {
  opacity: 0;
  transform: scale(0.98);
}
.fxg6deb {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}
.fxg6dec {
  align-items: center;
  justify-content: center;
  min-height: 320px;
}
@container fxg6de0 (max-width: 640px) {
  .fxg6de2 {
    grid-template-columns: minmax(0, 1fr);
    grid-template-areas: "main" "rail";
  }
  .fxg6de3 {
    border-right: none;
    border-top: var(--pluma-border-width-0125) solid var(--pluma-color-scope-neutral-subtle-border);
  }
}
@media (prefers-reduced-motion: reduce) {
  .fxg6dea {
    transition: none;
  }
}